import gql from 'graphql-tag';

import integrationItemFragment from '../fragments/integrationItemFragment';

export const mutationRenameIntegrationItem = gql`
  mutation renameIntegrationItem (
    $integrationID: DokkioID!
    $remoteID: ID!
    $newName: String!
  ) {
    renameIntegrationItem (
      integrationID: $integrationID
      remoteID: $remoteID
      newName: $newName
    ) {
      ...integrationItemFragment
    }
  }
  ${integrationItemFragment}
`;
export default mutationRenameIntegrationItem;
